import Vue from 'vue';
import { encodePathSegment } from '@/utils/url';

export default order => Vue.$http
    .patch(`Orders/${encodePathSegment(order.id)}`, order);



// WEBPACK FOOTER //
// ./src/services/order/edit.js